import { render, staticRenderFns } from "./retained-float.vue?vue&type=template&id=2506fddf&scoped=true"
import script from "./retained-float.vue?vue&type=script&lang=js"
export * from "./retained-float.vue?vue&type=script&lang=js"
import style0 from "./retained-float.vue?vue&type=style&index=0&id=2506fddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506fddf",
  null
  
)

export default component.exports